import {Injectable} from '@angular/core';
import {ChangePasswordProxy} from "./change.password.proxy";
import {IChangePasswordRequest, IChangePasswordResponse} from "../types";
import {HttpObservable} from "../../http-helpers/http.wrapper";

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  constructor(private changePasswordProxy: ChangePasswordProxy) {
  }

  public changePassword(changePasswordRequest: IChangePasswordRequest): HttpObservable<IChangePasswordResponse> {
    return this.changePasswordProxy.changePassword(changePasswordRequest);
  }
}
